module.exports = __webpack_public_path__ + "img/190558.f5572d29.jpg";